<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent fullscreen scrollable)
  v-card.neutral200
    v-card-text.pt-8.pb-0
      .d-flex.justify-center
        v-container.pa-8(fluid style="width:2000px")
          v-progress-linear.mb-2(v-if="isFetchingAfterMounted" :width="4" rounded color="primary" indeterminate)
          //- Title
          .text-2xl.neutral700--text.font-semibold.mb-4(v-if="isAddNew") {{ getTitle }}
          //- Loader
          template(v-if="isFetching")
            v-skeleton-loader.mx-1(v-for="n in 5" :key="`sl-${n}`" type="article")
          template(v-else-if="isError")
            .d-flex.align-center.justify-center(style="height: 70dvh")
              .d-flex.flex-column.align-center.justify-center
                v-icon.mb-2(color="danger500" size="50") mdi-alert-circle
                .text-lg.mb-4.danger500--text Error fetching data
          template(v-else)
            //- Header 
            document-header(v-if="!isAddNew" :parentData="parentData" :selectedDocument="selectedDocument" :selectedItems="itemInformations.items" :dueAmount="itemInformations.dueAmount" @updated="handleRefetch" @invoiceStatusChanged="handleInvoiceStatusChanged")
            //- e-Invoice details (invoice only)
            // TODO open this when in phase 2
            //document-e-invoice-details(v-if="selectedDocument.id === 'invoice'" v-model="eInvoiceDetails" :parentData="parentData" :selectedDocument="selectedDocument")
            //- Order information
            document-order-information(ref="orderInformationForm" v-model="orderInformations" :parentData="parentData" :selectedDocument="selectedDocument" @request-source-company-change="handleRequestSourceCompanyChange")
            //- Item information
            document-item-information(ref="itemInformationForm" v-model="itemInformations" :parentData="parentData" :selectedDocument="selectedDocument" :injectItems="injectItems" :sourceCompanySlug="orderInformations.sourceCompany && orderInformations.sourceCompany.slug" @updated="handleRefetch")
            //- Delivery details
            document-delivery-details(v-model="deliveryDetails" :parentData="parentData" :selectedDocument="selectedDocument")
            //- Remarks and attachment
            document-remarks-attachment(v-model="remarksAttachment" :parentData="parentData" :selectedDocument="selectedDocument")
          
    v-card-actions.white.pa-0
      .d-flex.flex-column(style="width:100%")
        v-divider
        .d-flex.justify-end.pa-4
          v-btn.button-md.neutral700--text.underline.mr-2(text @click="handleCloseDialog") Cancel
          //- Archived status
          template(v-if="getStatus === 'archived'")
            v-btn.button-md(:loading="isLoading" :disabled="isFetching || isError || isLoading" color="primary" depressed @click="openDocumentUnarchiveConfirmationDialog = true") Unarchive
          //- Quotation actions
          template(v-if="selectedDocument.id === 'quotation'")
            //- Draft status
            template(v-if="getStatus === 'draft'")
              v-btn.button-md.neutral700--text.mr-2(outlined :disabled="isFetching || isError || isLoading" @click="handleSave") Save and close
              v-btn.button-md(:loading="isLoading" :disabled="isFetching || isError || isLoading" color="primary" depressed @click="handleCreate") Create and send quotation
            //- Created status
            template(v-else-if="getStatus === 'created'")
              v-btn.button-md.neutral700--text.mr-2(outlined :disabled="isFetching || isError || isLoading" @click="openShareQuotationRequestDialog = true") Resend quotation
              v-btn.button-md(:loading="isLoading" :disabled="isFetching || isError || isLoading" color="primary" depressed @click="handleConvertToPurchaseOrder") Convert to purchase order
          //- Purchase order actions
          template(v-if="selectedDocument.id === 'purchase-order'")
            //- Draft status
            template(v-if="getStatus === 'draft'")
              v-btn.button-md.neutral700--text.mr-2(outlined :disabled="isFetching || isError || isLoading" @click="handleSave") Save as draft
              v-btn.button-md(:loading="isLoading" :disabled="isFetching || isError || isLoading" color="primary" depressed @click="handleCreateAndMarkOrdered") Create and mark ordered
            //- Active status 
            template(v-else-if="getStatus === 'active'")
              v-btn.button-md(:loading="isLoading" :disabled="isFetching || isError || isLoading" color="primary" depressed @click="handleSave") Update
            //- Complete status 
            template(v-else-if="getStatus === 'completed'")
              v-btn.button-md(:loading="isLoading" :disabled="isFetching || isError || isLoading" color="primary" depressed @click="openDocumentEditConfirmationDialog = true") Edit 
          //- Stock transfer actions
          template(v-if="selectedDocument.id === 'stock-transfer'")
            //- Draft status
            template(v-if="getStatus === 'draft'")
              v-btn.button-md.neutral700--text.mr-2(outlined :disabled="isFetching || isError || isLoading" @click="handleSave") Save as draft
              v-btn.button-md(:loading="isLoading" :disabled="isFetching || isError || isLoading" color="primary" depressed @click="handleCreateStockTransfer") Create and send stock transfer request
            //- Requested status (creator view)
            template(v-else-if="getStatus === 'requested'")
              v-btn.button-md(:loading="isLoading" :disabled="isFetching || isError || isLoading" color="primary" depressed @click="handleSave") Resend stock transfer request
            //- Approved status — only the sender (source company, or its HQ for warehouses) can convert to invoice
            template(v-else-if="getStatus === 'approved'")
              v-btn.button-md.neutral700--text.mr-2(outlined :loading="isLoading" :disabled="isFetching || isError || isLoading" @click="handleSave") Update
              v-btn.button-md(v-if="canConvertToInvoice" :loading="isLoading" :disabled="isFetching || isError || isLoading" color="primary" depressed @click="handleConvertToInvoice") Convert to invoice
          //- Invoice actions
          template(v-if="selectedDocument.id === 'invoice'")
            //- Draft status
            template(v-if="getStatus === 'draft'")
              v-btn.button-md.neutral700--text.mr-2(outlined :disabled="isFetching || isError || isLoading" @click="handleSave") Save as draft
              v-btn.button-md(:loading="isLoading" :disabled="isFetching || isError || isLoading" color="primary" depressed @click="handleRecordInvoice") Record invoice
            //- Active status 
            template(v-else-if="getStatus === 'active'")
              v-btn.button-md(:loading="isLoading" :disabled="isFetching || isError || isLoading" color="primary" depressed @click="handleSave") Update
            //- Complete status 
            template(v-else-if="getStatus === 'completed'")
              v-btn.button-md(:loading="isLoading" :disabled="isFetching || isError || isLoading" color="primary" depressed @click="openDocumentEditConfirmationDialog = true") Edit 
  .dialogs
    document-unarchive-confirmation-dialog(v-if="openDocumentUnarchiveConfirmationDialog" :open.sync="openDocumentUnarchiveConfirmationDialog" :parentId="parentData.id" :selectedDocument="selectedDocument" @updated="handleRefetch")
    share-quotation-request-dialog(v-if="openShareQuotationRequestDialog" :open.sync="openShareQuotationRequestDialog" :parentData="parentData")
    document-create-and-mark-ordered-confirmation-dialog(v-if="openDocumentCreateAndMarkOrderedConfirmationDialog" :open.sync="openDocumentCreateAndMarkOrderedConfirmationDialog" @confirmed="handleConfirmedCreateAndMarkOrdered")
    document-edit-confirmation-dialog(v-if="openDocumentEditConfirmationDialog" :open.sync="openDocumentEditConfirmationDialog" :selectedDocument="selectedDocument" :parentData="parentData" @updated="handleRefetch")
    document-update-item-changes-confirmation-dialog(v-if="openItemChangesConfirmationDialog" :open.sync="openItemChangesConfirmationDialog" :items="itemsThatChanged" @confirmed="handleConfirmedItemChanged")
    document-change-location-confirmation-dialog(v-if="openChangeLocationConfirmationDialog" :open.sync="openChangeLocationConfirmationDialog" @confirmed="handleConfirmedChangeLocation" @canceled="handleCanceledChangeLocation")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DocumentHeader from '@/components/clinic/purchasehub/document/documentheader/DocumentHeader.vue'
import DocumentOrderInformation from '@/components/clinic/purchasehub/document/DocumentOrderInformation.vue'
import DocumentItemInformation from '@/components/clinic/purchasehub/document/DocumentItemInformation.vue'
import DocumentDeliveryDetails from '@/components/clinic/purchasehub/document/DocumentDeliveryDetails.vue'
import DocumentRemarksAttachment from '@/components/clinic/purchasehub/document/DocumentRemarksAttachment.vue'
import DocumentEInvoiceDetails from '@/components/clinic/purchasehub/document/DocumentEInvoiceDetails.vue'
import DocumentUnarchiveConfirmationDialog from '@/components/clinic/dialogs/purchasehub/DocumentUnarchiveConfirmationDialog.vue'
import ShareQuotationRequestDialog from '@/components/clinic/dialogs/purchasehub/ShareQuotationRequestDialog.vue'
import DocumentCreateAndMarkOrderedConfirmationDialog from '@/components/clinic/dialogs/purchasehub/DocumentCreateAndMarkOrderedConfirmationDialog.vue'
import DocumentEditConfirmationDialog from '@/components/clinic/dialogs/purchasehub/DocumentEditConfirmationDialog.vue'
import DocumentUpdateItemChangesConfirmationDialog from "@/components/clinic/dialogs/purchasehub/DocumentUpdateItemChangesConfirmationDialog.vue";
import DocumentChangeLocationConfirmationDialog from '@/components/clinic/dialogs/purchasehub/DocumentChangeLocationConfirmationDialog.vue'

export default {
  components: {
    DocumentHeader, DocumentOrderInformation, DocumentItemInformation, DocumentDeliveryDetails, DocumentRemarksAttachment, DocumentEInvoiceDetails, DocumentUnarchiveConfirmationDialog,
    ShareQuotationRequestDialog, DocumentCreateAndMarkOrderedConfirmationDialog, DocumentEditConfirmationDialog,
    DocumentUpdateItemChangesConfirmationDialog, DocumentChangeLocationConfirmationDialog,
  },
  props: {
    open: {
      type: Boolean,
    },
    parentId: {
      type: Number,
      default: null
    },
    selectedDocument: {
      type: Object,
      required: true
    },
    injectItems: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      isLoading: false,
      isFetching: false,
      isFetchingAfterMounted: false,
      hasMounted: false,
      isError: false,
      parentData: null,
      openDocumentUnarchiveConfirmationDialog: false,
      openShareQuotationRequestDialog: false,
      openDocumentCreateAndMarkOrderedConfirmationDialog: false,
      openDocumentEditConfirmationDialog: false,
      openItemChangesConfirmationDialog: false,
      openChangeLocationConfirmationDialog: false,
      pendingSourceCompany: null,
      createdFromNew: false,
      itemInformations: {
        items: [],
      },
      orderInformations: {},
      deliveryDetails: {},
      remarksAttachment: {},
      eInvoiceDetails: {},
      invoiceStatusChange: null
    }
  },
  async mounted () {
    if (!this.isAddNew) {
      await this.fetchData()
    }
    this.hasMounted = true
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      isHq: 'hq/getIsHq',
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    payload () {
      const commonPayload = {
        supplier: this.orderInformations.supplier?.id || null,
        source_company: this.orderInformations.sourceCompany?.id || null,
        destination_company: this.orderInformations.sendTo?.id || null,
        requested_by: this.orderInformations.requestedBy || null,
        remarks: this.remarksAttachment.remarks,
      }
      if (this.selectedDocument.id === 'quotation') {
        return {
          ...commonPayload,
          ...this.getQuotationPayload()
        }
      }
      if (this.selectedDocument.id === 'purchase-order') {
        return {
          ...commonPayload,
          ...this.getPurchaseOrderPayload()
        }
      }
      if (this.selectedDocument.id === 'invoice') {
        return {
          ...commonPayload,
          ...this.getInvoicePayload()
        }
      }
      if (this.selectedDocument.id === 'stock-transfer') {
        return {
          ...commonPayload,
          ...this.getStockTransferPayload()
        }
      }
      return commonPayload
    },
    isAddNew () {
      if (this.createdFromNew) {
        return false
      }
      return this.parentId === null
    },
    getStatus () {
      if (this.isAddNew) return 'draft'
      if (this.selectedDocument.id === 'quotation') return this.parentData?.request_status
      return this.parentData?.order_status
    },
    getTitle () {
      return `New ${this.selectedDocument.id.split('-').join(' ')}`
    },
    itemsThatChanged () {
      return this.itemInformations.items.filter(item => this.hasStockReceivedQtyChanges(item) || this.hasCostChanges(item))
    },
    canConvertToInvoice () {
      const source = this.parentData?.source_company
      if (!source) return false
      return this.company.slug === source.slug
        || this.company.slug === source.branch_of?.slug
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    async fetchData (id = null) {
      try {
        if (this.hasMounted) {
          this.isFetchingAfterMounted = true
        } else {
          this.isFetching = true
        }
        const endpoint = `${this.getEndpoint()}/${id ?? this.parentId}`
        const { data } = await this.axios.get(endpoint)
        this.parentData = data
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        this.isError = true
      } finally {
        this.isFetching = false
        this.isFetchingAfterMounted = false
        this.isLoading = false
      }
    },
    handleCloseDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
    validateSupplierItemsDate () {
      if (!this.isValidSupplier() || !this.isValidSendTo() || !this.isValidItems() || !this.isValidRecordDate()) {
        return false
      }

      return true
    },
    async handleCreate () {
      if (!this.validateSupplierItemsDate()) {
        return
      }
      this.isLoading = true
      const payload = {
        ...this.payload,
      }
      if (this.selectedDocument.id === 'quotation') {
        payload.request_status = 'created'
      } else {
        payload.order_status = 'active'
      }
      const { id } = await this.handleRequest(payload)
      await this.handleAfterRequest(id, true)
    },
    async handleRecordInvoice ({hasConfirmedChanges = false, status = 'active'}) {
      try {
        if (!this.validateSupplierItemsDate()) {
          return
        }
        if (this.validateItemChangedCondition() && !hasConfirmedChanges) {
          this.openItemChangesConfirmationDialog = true
          this.isLoading = false
          return
        }
        this.isLoading = true
        const payload = {
          ...this.payload,
          order_status: status
        }

        await this.handleRequest(payload)
        this.showMessage(['success', 'Successfully record invoice'])
        this.handleCloseDialog()
      } catch (error) {
        this.isLoading = false
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      }
    },
    async handleSave ({ closeAfterFinished = true, hasConfirmedChanges = false }) {
      try {
        this.isLoading = true
        if (!this.validateSupplierItemsDate()) {
          this.isLoading = false
          return
        }
        if (this.validateItemChangedCondition(true) && !hasConfirmedChanges) {
          this.openItemChangesConfirmationDialog = true
          this.isLoading = false
          return
        }
        const payload = {...this.payload}
        const { id } = await this.handleRequest(payload)
        await this.handleAfterRequest(id, false, closeAfterFinished)
        this.showMessage(['success', `Successfully ${this.isAddNew ? 'created' : 'updated'} ${this.selectedDocument.id}`])
      } catch (error) {
        this.isLoading = false
        this.openItemChangesConfirmationDialog = false
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      }
    },
    validateItemChangedCondition (validateOnlyActive = false) {
      let validation = this.selectedDocument.id !== 'quotation' && this.selectedDocument.id !== 'stock-transfer' && this.itemsThatChanged.length > 0
      if (validateOnlyActive) {
        validation = validation && this.getStatus === 'active'
      }
      return validation
    },
    // Deprecated (to be removed later)
    // async handleInventoryUpdate (id, data) {
    //   this.mapItemsIdAfterRequest(data)
    //   const endpoint = `${this.getEndpoint()}/${id}/inventories`
    //   const payload = this.getItemsThatChangedPayload()
    //   const resp = await this.axios.post(endpoint, payload)
    //   this.updateActivityLog(endpoint, payload, resp.data, 'POST', id, 'Inventory updated')
    // },
    // mapItemsIdAfterRequest (newData) {
    //   newData.items.map((item, itemIdx) => {
    //     this.itemInformations.items[itemIdx].id = item.id
    //   })
    // },
    getEndpoint () {
      const baseEndpoint = `/purchases/${this.company.slug}`
      switch (this.selectedDocument.id) {
        case 'quotation':
          return `${baseEndpoint}/quotations`

        case 'purchase-order':
          return `${baseEndpoint}/orders`

        case 'invoice':
          return `${baseEndpoint}/invoices`

        case 'stock-transfer':
          return `${baseEndpoint}/stock-transfers`

        default:
          return ''
      }
    },
    async handleRequest (payload) {
      const endpoint = this.getEndpoint()
      let id
      let data
      if (this.isAddNew) {
        const resp = await this.axios.post(endpoint, payload)
        this.updateActivityLog(endpoint, payload, resp.data, 'POST', resp.data.id)
        id = resp.data.id
        data = resp.data
      } else {
        const resp = await this.axios.patch(`${endpoint}/${this.parentId}`, payload)
        this.updateActivityLog(endpoint, payload, resp.data, 'PATCH', this.parentId)
        id = this.parentId
        data = resp.data
      }
      await this.handleUploadAttachment(id)
      this.$emit('updated')
      return { id, data }
    },
    async handleUploadAttachment (id) {
      if (!this.remarksAttachment?.attachment?.length || this.remarksAttachment?.attachment?.some(file => file?.id)) {
        return true
      }
      for (const file of this.remarksAttachment.attachment) {
        const formData = new FormData()
        switch (this.selectedDocument.id) {
          case 'quotation':
            formData.append('quotation', id)
            break

          case 'purchase-order':
            formData.append('order', id)
            break

          case 'invoice':
            formData.append('invoice', id)
            break

          case 'stock-transfer':
            formData.append('order', id)
            break

          default:
            break
        }
        formData.append('file', file)
        formData.append('name', file.name)
        await this.$axios.post(`/purchases/${this.company.slug}/attachments`, formData)
      }
    },
    async handleAfterRequest (id, created, closeAfterFinished = true) {
      if (!id) {
        return
      }

      if (created) {
        this.createdFromNew = true
        this.parentId = id
        await this.fetchData(id)
        if (this.selectedDocument.id === 'quotation') this.openShareQuotationRequestDialog = true
        return
      }

      if (closeAfterFinished) {
        this.handleCloseDialog()
      }
    },
    isValidRecordDate () {
      if (!this.payload.record_date) {
        let message = 'Please add '
        switch (this.selectedDocument.id) {
          case 'quotation':
            message += 'quotation date'
            break
          
          case 'purchase-order':
            message += 'purchase order date'
            break

          case 'invoice':
            message += 'invoice date'
            break

          case 'stock-transfer':
            message += 'stock transfer request date'
            break

          default:
            break
        }
        this.showMessage(['error', message])
        return false
      }
      return true
    },
    isValidSupplier () {
      if (this.selectedDocument.id === 'stock-transfer') {
        if (!this.payload.source_company) {
          this.showMessage(['error', 'Please select a location'])
          return false
        }
        return true
      }
      if (!this.payload.supplier && !this.payload.source_company) {
        this.showMessage(['error', 'Please select a supplier'])
        return false
      }
      return true
    },
    isValidSendTo () {
      if (this.isHq && !this.orderInformations.sendTo) {
        this.showMessage(['error', 'Please select a destination'])
        return false
      }
      return true
    },
    isValidItems () {
      // Validate form fields first
      if (this.$refs.itemInformationForm && !this.$refs.itemInformationForm.validate()) {
        this.showMessage(['error', 'Please fix errors in the item table'])
        return false
      }
      if (this.payload.items.length === 0) {
        this.showMessage(['error', 'Please add at least one item to the list'])
        return false
      }
      if (this.selectedDocument.id !== 'invoice' && this.payload.items.some(item => !item.requested_qty)) {
        this.showMessage(['error', 'Please fill in the requested quantity for all items'])
        return false
      }
      if (this.selectedDocument.id !== 'quotation' && this.selectedDocument.id !== 'stock-transfer' && this.payload.items.some(item => item.total_cost === null)) {
        this.showMessage(['error', 'Please fill in total cost for all items'])
        return false
      }
      if (this.selectedDocument.id === 'invoice' && this.payload.items.some(item => item.received_qty === '')) {
        this.showMessage(['error', 'Please fill in received qty for all items'])
        return false
      }
      return true
    },
    handleRefetch () {
      this.fetchData()
      this.$emit('updated')
    },
    handleUpdateRequestStock () {
      // this.$vuetify.goTo(0)
    },
    updateActivityLog (endpoint, payload, response, method, id, activity = null) {
      let data = {
        company: this.company.id,
        object_id: id,
        object_ref: null,
        activity: activity ?? `${this.selectedDocument.id} ${method === 'POST' ? 'created' : 'updated'}`,
        raw_data: { endpoint, payload, response, method }
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
    getStockTransferPayload () {
      const isApproved = ['approved', 'completed'].includes(this.parentData?.order_status)
      return {
        record_date: this.orderInformations.quotationDate,
        delivery_details: {
          preferred_delivery_date: this.deliveryDetails.preferredDeliveryDate,
          preferred_delivery_method: this.deliveryDetails.preferredDeliveryMethod,
          priority: this.deliveryDetails.priority,
        },
        tax_amount: this.itemInformations?.tax,
        delivery_charge: this.itemInformations?.deliveryCharge,
        adjustment_amount: this.itemInformations?.paymentAdjustment,
        items: this.itemInformations.items.map(item => {
          const commonData = {
            product: item.product.id,
            requested_qty: item.requestedQty,
          }
          if (isApproved) {
            commonData.received_qty = item.receivedQty
            commonData.cost_per_item = item.costPerItem
            commonData.total_cost = item.totalCostInteger
            commonData.batch_no = item.batchNumber
            commonData.expiry_date = item.expiryDate
          }
          if (item.id) {
            return {
              ...commonData,
              id: item.id,
            }
          }
          return commonData
        })
      }
    },
    async handleCreateStockTransfer () {
      if (!this.validateSupplierItemsDate()) {
        return
      }
      try {
        this.isLoading = true
        const payload = {
          ...this.payload,
          order_status: 'requested',
        }
        const { id } = await this.handleRequest(payload)
        await this.handleAfterRequest(id, true)
      } catch (error) {
        const detail = error?.response?.data?.items?.[0] || error?.response?.data?.detail
        this.showMessage(['error', detail || this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    getQuotationPayload () {
      // TODO: add delivery details to payload once API ready
      // preferred_delivery_date: this.deliveryDetails.preferredDeliveryDate,
      // preferred_delivery_method: this.deliveryDetails.preferredDeliveryMethod,
      // priority: this.deliveryDetails.priority,
      return {
        record_date: this.orderInformations.quotationDate,
        items: this.itemInformations.items.map(item => {
          const commonData = {
            product: item.product.id,
            requested_qty: item.requestedQty,
          }
          if (item.id) {
            return {
              ...commonData,
              id: item.id,
            }
          }
          return commonData
        })
      }
    },
    getPurchaseOrderPayload () {
      // TODO: add delivery details to payload once API ready
      // preferred_delivery_date: this.deliveryDetails.preferredDeliveryDate,
      // preferred_delivery_method: this.deliveryDetails.preferredDeliveryMethod,
      // priority: this.deliveryDetails.priority,
      return {
        record_date: this.orderInformations.recordDate,
        due_date: this.orderInformations.dueDate,
        payment_terms: this.orderInformations.paymentTerms,
        tax_amount: this.itemInformations?.tax,
        delivery_charge: this.itemInformations?.deliveryCharge,
        adjustment_amount: this.itemInformations?.paymentAdjustment,
        items: this.itemInformations.items.map(item => {
          const commonData = {
            product: item.product.id,
            requested_qty: item.requestedQty,
            received_qty: item.receivedQty,
            cost_per_item: item.costPerItem,
            total_cost: item.totalCostInteger,
            batch_no: item.batchNumber,
            expiry_date: item.expiryDate,
          }
          if (item.id) {
            return {
              ...commonData,
              id: item.id,
            }
          }
          return commonData
        })
      }
    },
    getInvoicePayload () {
      // TODO: add delivery details to payload once API ready
      // preferred_delivery_date: this.deliveryDetails.preferredDeliveryDate,
      // preferred_delivery_method: this.deliveryDetails.preferredDeliveryMethod,
      // priority: this.deliveryDetails.priority,
      return {
        record_date: this.orderInformations.recordDate,
        due_date: this.orderInformations.dueDate,
        payment_terms: this.orderInformations.paymentTerms,
        tax_amount: this.itemInformations?.tax,
        delivery_charge: this.itemInformations?.deliveryCharge,
        adjustment_amount: this.itemInformations?.paymentAdjustment,
        items: this.itemInformations.items.map(item => {
          const commonData = {
            product: item.product.id,
            requested_qty: item.requestedQty,
            received_qty: item.receivedQty,
            cost_per_item: item.costPerItem,
            total_cost: item.totalCostInteger,
            batch_no: item.batchNumber,
            expiry_date: item.expiryDate,
          }
          if (item.id) {
            return {
              ...commonData,
              id: item.id,
            }
          }
          return commonData
        })
      }
    },
    handleCreateAndMarkOrdered () {
      if (!this.validateSupplierItemsDate()) {
        return
      }
      this.openDocumentCreateAndMarkOrderedConfirmationDialog = true
    },
    async handleConfirmedCreateAndMarkOrdered () {
      await this.handleCreate()
      this.openDocumentCreateAndMarkOrderedConfirmationDialog = false
      this.handleCloseDialog()
    },
    async handleConvertToPurchaseOrder () {
      try {
        this.isLoading = true
        const endpoint = `/purchases/${this.company.slug}/quotations/${this.parentData.id}/convert_to_order`
        const resp = await this.axios.post(endpoint)
        this.updateActivityLog(endpoint, null, resp, 'POST', this.parentData.id, 'Quotation converted to purchase order')
        this.showMessage(['success', 'Successfully converted to purchase order'])
        this.$emit('updated')
        this.handleCloseDialog()
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    async handleConvertToInvoice () {
      try {
        this.isLoading = true
        const endpoint = `/purchases/${this.company.slug}/stock-transfers/${this.parentData.id}/convert_to_invoice`
        const resp = await this.axios.post(endpoint)
        this.updateActivityLog(endpoint, null, resp, 'POST', this.parentData.id, 'Stock transfer converted to invoice')
        this.showMessage(['success', 'Successfully converted to invoice'])
        this.$emit('updated')
        this.handleCloseDialog()
      } catch (error) {
        const detail = error.response && error.response.data && error.response.data.detail
        this.showMessage(['error', detail || this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    hasStockReceivedQtyChanges (item) {
      return item.receivedQty !== item.originalReceivedQty
    },
    hasCostChanges (item) {
      return item.costPerItem !== item.originalCost
    },
    // Deprecated (to be removed later)
    // getItemsThatChangedPayload () {
    //   const inventories = this.itemsThatChanged
    //       .filter(item => item.receivedQty !== item.originalReceivedQty)
    //       .map(item => {
    //         const change = item.receivedQty - item.originalReceivedQty
    //         return {
    //           purchase_item: item.id,
    //           action: change > 0 ? 'received' : 'adjust',
    //           change
    //         }
    //       })
    //   return { inventories }
    // },
    handleConfirmedItemChanged () {
      if (this.selectedDocument.id === 'invoice') {
        const params = {
          hasConfirmedChanges: true,
        }
        if (this.invoiceStatusChange) {
          params.status = this.invoiceStatusChange
        }
        this.handleRecordInvoice(params)
        return
      }
      this.handleSave({ hasConfirmedChanges: true })
    },
    handleInvoiceStatusChanged (status) {
      this.invoiceStatusChange = status
      this.handleRecordInvoice({ status })
    },
    handleRequestSourceCompanyChange (newValue) {
      const isStockTransfer = this.selectedDocument.id === 'stock-transfer'
      const hasItems = this.itemInformations.items && this.itemInformations.items.length > 0
      if (!isStockTransfer || !hasItems) {
        this.$refs.orderInformationForm.commitSourceCompany(newValue)
        return
      }
      this.pendingSourceCompany = newValue
      this.openChangeLocationConfirmationDialog = true
    },
    handleConfirmedChangeLocation () {
      if (this.$refs.itemInformationForm) {
        this.$refs.itemInformationForm.clearItems()
      }
      if (this.$refs.orderInformationForm) {
        this.$refs.orderInformationForm.commitSourceCompany(this.pendingSourceCompany)
      }
      this.pendingSourceCompany = null
      this.openChangeLocationConfirmationDialog = false
    },
    handleCanceledChangeLocation () {
      if (this.$refs.orderInformationForm) {
        this.$refs.orderInformationForm.revertSourceCompanySelection()
      }
      this.pendingSourceCompany = null
      this.openChangeLocationConfirmationDialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .combostyle .v-input__icon {
    min-width: 22px;
    width: 22px;
    margin-top: 4px;
  }
}
.file-layout {
  position: relative;
  cursor: pointer;
  border: var(--v-neutral400) dashed 1px;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
</style>